export default "__VITE_ASSET__CjIefBIi__"